import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { rejectBooking } from 'redux/booking/car/carBookingSlice';
import { Modal, Button, Alert } from 'components/common';

const TransactionDetailRejectModal = ({ showModal, setshowModal, transaction }) => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const dispatch = useDispatch();

  const closeModal = () => setshowModal(false);

  const onSubmit = (data) => {
    try {
      dispatch(rejectBooking({ transactionId: transaction.id, data: { reason: data.remark } }));
      closeModal();
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      title="Reject car booking"
      size="lg"
      footer={(
        <>
          <Button size="sm" variant="secondary" onClick={closeModal}>Cancel</Button>
          <Button size="sm" type="submit" form="reject-car-booking-form" variant="danger">Reject</Button>
        </>
      )}
    >
      <form id="reject-car-booking-form" onSubmit={handleSubmit(onSubmit)}>
        <Alert type="warning" className="tw-mb-4">
          Specify the reason for rejecting the booking.
        </Alert>

        <label className="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Reason</label>
        <textarea
          rows={6}
          placeholder="Reason"
          className="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-solid tw-border-slate-300 tw-rounded-md tw-text-sm tw-text-slate-900 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
          {...register('remark', { required: 'Reason must be required' })}
        />
        {errors.remark && <p className="tw-text-xs tw-text-red-600 tw-mt-1 tw-mb-0">{errors.remark.message}</p>}
      </form>
    </Modal>
  );
};

TransactionDetailRejectModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  transaction: PropTypes.object.isRequired,
};

export default TransactionDetailRejectModal;
